import { Fragment, useEffect, useState } from 'react';
import { useBlocker } from 'react-router-dom';
import { Button } from 'tdesign-react';

import NovaDialog from '../dialog';

/**
 * 路由变化监测，未保存则提示
 */
function NovaPrompt(props: {
  when: boolean;
  message?: string | React.ReactElement;
  confirmCallback?: () => void;
  cancelCallback?: () => void;
}) {
  const { when, message, confirmCallback, cancelCallback } = props;
  const block = when;

  const [visible, setVisible] = useState(false);

  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    if (block && currentLocation.pathname !== nextLocation.pathname) {
      setVisible(true);
      return true;
    }
    return false;
  });

  useEffect(() => {
    const handleBeforeUnload = (event: {
      preventDefault: () => void;
      returnValue: string;
    }) => {
      if (block) {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    const handleUnload = () => {
      if (block) {
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
    };
  }, [block]);

  if (!when) return;

  const leave = () => {
    setVisible(false);
    confirmCallback?.();
    blocker?.proceed?.();
  };

  const stay = () => {
    setVisible(false);
    cancelCallback?.();
    blocker?.reset?.();
  };

  return (
    <Fragment>
      <NovaDialog
        dialogConfig={{
          visible,
          closeBtn: false,
          onClose: stay,
          confirmBtn: (
            <Button theme='primary' onClick={stay}>
              去保存
            </Button>
          ),
          cancelBtn: (
            <Button theme='default' onClick={leave}>
              确定离开
            </Button>
          ),
          theme: 'warning',
          header: message
            ? message
            : '在离开页面之前，请确保保存您所做的更改。',
        }}
      ></NovaDialog>
    </Fragment>
  );
}

export default NovaPrompt;
